import CookieToggle from './CookieToggle';

export default CookieToggle;



// WEBPACK FOOTER //
// ./src/presentation/components/cookie-toggle/index.js